import { createFileRoute } from "@tanstack/react-router";
import AdminImageDetailPage from "@/admin/pages/image-detail";

export const Route = createFileRoute("/admin/images/$id")({
  component: AdminImageDetailPage,
});
